import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareAuthenticatedHeaders } from './utils/headers'
import { ParticipantStatus } from '../types'

export interface RegisterParams {
  event_id: number
  options: {
    option_id: number
    value: string
  }[]
}

export interface RegisterResponse {
  status: ParticipantStatus
  checkout_url: string
}

export const registrationApi = createApi({
  reducerPath: 'registrationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_URL}/api/v1/register`,
    prepareHeaders: prepareAuthenticatedHeaders,
  }),
  tagTypes: ['Registration'],
  endpoints: builder => ({
    register: builder.mutation<RegisterResponse, RegisterParams>({
      query: data => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const { useRegisterMutation } = registrationApi
